import { TWS_API_URL } from '../environment/apis.config'
import { timeouts } from '../services/RequestTimeouts'
import { getAccessToken } from '../utils/auth.util'

const API_URL = `${TWS_API_URL}/swaps`

// TODO: Pass the current location in the API
export const getVideoURL = (location: any): Promise<string> => {
  const controller = new AbortController()

  return new Promise(async (resolve, reject) => {
    const timeoutId = setTimeout(() => {
      controller.abort()
      reject(new Error('Request Timeout'))
    }, timeouts.customProfile)
    const token = await getAccessToken()

    fetch(`${API_URL}/videos`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      signal: controller.signal,
    })
      .then(async (res) => {
        if (res.status === 200) {
          const { video_url } = await res.json()
          // store.dispatch(updateCustomUnits(units))
          resolve(video_url)
        } else {
          throw new Error('Network request failed while getting 3D Winds')
        }
        clearTimeout(timeoutId)
        if (!res.ok) {
          throw new Error('Network request failed while getting 3D Winds')
        }
        return res.json()
      })
      .catch((err) => {
        if (err.name === 'AbortError') {
          reject(new Error('Network request timeout while getting 3D Winds'))
        } else {
          reject(err)
        }
      })
  })
}
